import { BaseCompanyProps } from "@custom-types/base-types";
import { DateTimeUtils } from "@stellar/utils";
import { WorkspaceInfoActions } from "@pages/workspace-profile/tab-contents/workspace-info-tab/workspace-info-actions";
import { CopyTextButton } from "@components/copy-text-button";
import { GeneralProfileEvents } from "@utils/track-event/track-event-list";
import { ProfileInfoTab } from "@components/profile-info-tab";

/** Content inside the information tab */
export function WorkspaceInfo({
  company,
}: BaseCompanyProps): React.JSX.Element {
  return (
    <ProfileInfoTab
      contents={[
        {
          label: "ID",
          value: company.id,
          action: (
            <CopyTextButton
              textToCopy={company.id}
              successMessage="Workspace ID copied to clipboard"
              failedMessage="Error: Failed to copy workspace ID to clipboard"
              trackEventName={{
                name: GeneralProfileEvents.copyToClipboard,
                props: {
                  entityKey: "Id",
                  location: "workspace profile info tab",
                  target: "COMPANY",
                },
              }}
            />
          ),
          shouldAddDividerBelow: true,
        },
        {
          label: "Created",
          value: DateTimeUtils.formatDateTimeInUtc({
            date: company.createdAt,
          }),
          shouldAddDividerBelow: true,
        },
        {
          label: "Total Projects",
          value: company.projectCount,
        },
        {
          label: "Total Members",
          value: company.memberCount,
        },
      ]}
      actionButtons={<WorkspaceInfoActions company={company} />}
    />
  );
}
